import React, { useEffect, useState, useRef } from "react";
import { provinceOptions } from "../../js/utils";
import InputData from "../../components/InputData";
import ButtonIconH from "../../components/ButtonIconH";
import Dropdown from "../../components/Dropdown";
import Tab from "./Tab";
import InputTextAreaContainer from "./InputTextAreaContainer";
import TablaIVA from "./TablaIVA";
import CheckBox from "../../components/CheckBox";
import PopupCP from "../../support-extra/components/PopupCP";

import { post } from "../utils/api";
import { userData } from "../../js/utils";
import LogoImg from "./LogoImg";

import "../css/OpticScreen.css";

//let json_optica = [];
const tokenSesion = userData ? userData.token : "";

export default function OpticScreen(props) {
  const [idOptica, setIdOptica] = useState(props.opticId);
  const [idEmpresa, setIdEmpresa] = useState(props.companyId);
  const [nombre, setNombre] = useState("");
  const [nombreCorto, setNombreCorto] = useState("");
  const [NRS, setNRS] = useState("");
  const [direccion, setDireccion] = useState("");
  const [codigoPostal, setCodigoPostal] = useState("");
  const [localidad, setLocalidad] = useState("");
  const [provincia, setProvincia] = useState("");
  const [telefono, setTelefono] = useState("");
  const [movil, setMovil] = useState("");
  const [email, setEmail] = useState("");
  const [textoRGPD, setTextoRGPD] = useState("");
  const [consentimientoOrtoK, setConsentimientoOrtoK] = useState("");
  const [consentimientoLC, setConsentimientoLC] = useState("");
  const [consentimientoAudio, setConsentimientoAudio] = useState("");
  const [cartaGarantia, setCartaGarantia] = useState("");
  const [justificanteAsistencia, setJustificanteAsistencia] = useState("");
  const [clausulasFacturasPresupuestos, setClausulasFacturasPresupuestos] =
    useState("");
  const [clausulasFichasPaciente, setClausulasFichasPaciente] = useState("");
  const [idTipoIVA, setIdTipoIVA] = useState(0);
  const [tieneRecargoEquivalencia, setTieneRecargoEquivalencia] =
    useState(false);

  const [errorEmail, setErrorEmail] = useState(false);
  const [errorCP, setErrorCP] = useState(false);
  const [selectedTabConsentimientos, setSelectedTabConsentimientos] =
    useState(0);
  const [selectedTabClausulas, setSelectedTabClausulas] = useState(6);

  const [isLoading, setIsLoading] = useState(false);

  const [originalData, setOriginalData] = useState(null);

  const [opticComercialLogo, setOpticComercialLogo] = useState(null);
  const opticComercialLogoName = "logo-comercial";
  const [flagNewComercialLogo, setFlagNewComercialLogo] = useState(false);
  const [flagDeleteComercialLogo, setFlagDeleteComercialLogo] = useState(false);
  const [opticTicketLogo, setOpticTicketLogo] = useState(null);
  const opticTicketLogoName = "logo-ticket";
  const [flagNewTicketLogo, setFlagNewTicketLogo] = useState(false);
  const [flagDeleteTicketLogo, setFlagDeleteTicketLogo] = useState(false);

  const [datosIVA, setDatosIVA] = useState([]);

  const [ivaSeleccionado, setIvaSeleccionado] = useState(null);

  const [showPopupCP, setShowPopupCP] = useState(false);
  const [cpPopupAddress, setCPPopupAddress] = useState("");
  const [cpPopupCity, setCPPopupCity] = useState("");

  useEffect(() => {
    if (errorCP) {
      props.createPopupQuestion(
        "Por favor, revise el código postal.",
        () => {
          const el = document.getElementById("codigo_postal");
          if (el) {
            el.focus();
          }
          setErrorCP(false);
          props.removePopupQuestion();
          return;
        },
        null,
        "Entendido",
      );
    }
  }, [errorCP]);

  // --- GESTIÓN DE FOCO GRUPO 1: Consentimientos (Tabs 0-5) ---
  const consentimientosRefs = useRef([]);

  useEffect(() => {
    const timer = setTimeout(() => {
      // Buscamos en el array usando el índice de la tab seleccionada
      const el = consentimientosRefs.current[selectedTabConsentimientos];
      if (el) el.focus();
    }, 50);
    return () => clearTimeout(timer);
  }, [selectedTabConsentimientos]);

  // --- GESTIÓN DE FOCO GRUPO 2: Cláusulas (Tabs 6-7) ---
  const clausulasRefs = useRef([]);

  useEffect(() => {
    const timer = setTimeout(() => {
      // Buscamos en el array. Como tus tabs son 6 y 7, usaremos esos mismos índices
      const el = clausulasRefs.current[selectedTabClausulas];
      if (el) el.focus();
    }, 50);
    return () => clearTimeout(timer);
  }, [selectedTabClausulas]);

  useEffect(() => {
    if (!isLoading) {
      const timer = setTimeout(() => {
        const nombreInput = document.getElementById("nombre");
        // Asegúrate de hacer focus al input o elemento interactivo
        if (nombreInput) nombreInput.focus();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [isLoading]);

  useEffect(() => {
    async function obtenerOptica() {
      //console.log("ÓPTICA RECIBIDA: ", props.opticId);
      if (props.opticId === -1) {
        // Nueva óptica → limpiar datos de la óptica
        setNombre("");
        setNombreCorto("");
        setNRS("");
        setDireccion("");
        setCodigoPostal("");
        setLocalidad("");
        setProvincia("");
        setTelefono("");
        setMovil("");
        setEmail("");
        setTextoRGPD("");
        setConsentimientoOrtoK("");
        setConsentimientoLC("");
        setConsentimientoAudio("");
        setCartaGarantia("");
        setJustificanteAsistencia("");
        setClausulasFacturasPresupuestos("");
        setClausulasFichasPaciente("");
        setIdTipoIVA(0);
        setTieneRecargoEquivalencia(false);
        // Nueva óptica → usar la empresa recibida
        setIdEmpresa(props.companyId);
        //console.log("EMPRESA RECIBIDA: ", props.companyId);
        setIdOptica(props.opticId);
        //console.log("ÓPTICA ASIGNADA: ", props.opticId);

        const newOpticData = {
          nombre: "",
          nombreCorto: "",
          NRS: "",
          direccion: "",
          codigoPostal: "",
          localidad: "",
          provincia: "",
          telefono: "",
          movil: "",
          email: "",
          textoRGPD: "",
          consentimientoOrtoK: "",
          consentimientoLC: "",
          consentimientoAudio: "",
          cartaGarantia: "",
          justificanteAsistencia: "",
          clausulasFacturasPresupuestos: "",
          clausulasFichasPaciente: "",
          idTipoIVA: 0,
          tieneRecargoEquivalencia: false,
        };

        setOriginalData(newOpticData); // Nueva Óptica: No hay datos originales.

        const tiposIVAResponse = await post(
          "Configuracion/ListarTiposIVAGeneral.php",
        );

        if (tiposIVAResponse) {
          setDatosIVA(tiposIVAResponse);
        }

        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      setIdOptica(props.opticId);

      let json_optica = [];
      let json_logo_comercial = [];
      let json_logo_ticket = [];
      let json_query = { token: tokenSesion, idOptica: props.opticId };

      json_optica = await post("Configuracion/ObtenerOptica.php", json_query);

      if (json_optica) {
        /*json_optica.forEach((opt) => {
          setIdEmpresa(opt.idEmpresa);
          setNombre(opt.nombre);
          setNombreCorto(opt.nombre_corto);
          setNRS(opt.NRS);
          setDireccion(opt.direccion);
          setCodigoPostal(opt.codigo_postal);
          setLocalidad(opt.localidad);
          setProvincia(opt.provincia);
          setTelefono(opt.telefono);
          setMovil(opt.movil);
          setEmail(opt.email);
          setTextoRGPD(opt.texto_rgpd);
          setConsentimientoOrtoK(opt.consentimiento_ortoK);
          setConsentimientoLC(opt.consentimiento_lc);
          setConsentimientoAudio(opt.consentimiento_audio);
          setCartaGarantia(opt.carta_garantia);
          setJustificanteAsistencia(opt.justificante_asistencia);
          setClausulasFacturasPresupuestos(opt.clausulas_facturas_presupuestos);
          setClausulasFichasPaciente(opt.clausulas_fichas_paciente);
        });*/

        const opticData = {
          nombre: json_optica.nombre,
          nombreCorto: json_optica.nombre_corto,
          NRS: json_optica.NRS,
          direccion: json_optica.direccion,
          codigoPostal: json_optica.codigo_postal,
          localidad: json_optica.localidad,
          provincia: json_optica.provincia,
          telefono: json_optica.telefono,
          movil: json_optica.movil,
          email: json_optica.email,
          textoRGPD: json_optica.texto_rgpd,
          consentimientoOrtoK: json_optica.consentimiento_ortoK,
          consentimientoLC: json_optica.consentimiento_lc,
          consentimientoAudio: json_optica.consentimiento_audio,
          cartaGarantia: json_optica.carta_garantia,
          justificanteAsistencia: json_optica.justificante_asistencia,
          clausulasFacturasPresupuestos:
            json_optica.clausulas_facturas_presupuestos,
          clausulasFichasPaciente: json_optica.clausulas_fichas_paciente,
          idTipoIVA: json_optica.idTipoIVA,
          tieneRecargoEquivalencia: Boolean(
            json_optica.tieneRecargoEquivalencia,
          ),
        };

        setIdEmpresa(json_optica.idEmpresa);
        setNombre(json_optica.nombre);
        setNombreCorto(json_optica.nombre_corto);
        setNRS(json_optica.NRS);
        setDireccion(json_optica.direccion);
        setCodigoPostal(json_optica.codigo_postal);
        setLocalidad(json_optica.localidad);
        setProvincia(json_optica.provincia);
        setTelefono(json_optica.telefono);
        setMovil(json_optica.movil);
        setEmail(json_optica.email);
        setTextoRGPD(json_optica.texto_rgpd);
        setConsentimientoOrtoK(json_optica.consentimiento_ortoK);
        setConsentimientoLC(json_optica.consentimiento_lc);
        setConsentimientoAudio(json_optica.consentimiento_audio);
        setCartaGarantia(json_optica.carta_garantia);
        setJustificanteAsistencia(json_optica.justificante_asistencia);
        setClausulasFacturasPresupuestos(
          json_optica.clausulas_facturas_presupuestos,
        );
        setClausulasFichasPaciente(json_optica.clausulas_fichas_paciente);
        setIdTipoIVA(json_optica.idTipoIVA);
        setTieneRecargoEquivalencia(
          Boolean(json_optica.tieneRecargoEquivalencia),
        );

        setOriginalData(opticData);

        json_logo_comercial = await post(
          "Configuracion/ObtenerLogoComercial.php",
          json_query,
        );

        if (json_logo_comercial) {
          setOpticComercialLogo(json_logo_comercial.logo);
          setFlagNewComercialLogo(false);
        }

        json_logo_ticket = await post(
          "Configuracion/ObtenerLogoTicket.php",
          json_query,
        );

        if (json_logo_ticket) {
          setOpticTicketLogo(json_logo_ticket.logo);
          setFlagNewTicketLogo(false);
        }

        const tiposIVAResponse = await post(
          "Configuracion/ListarTiposIVAGeneral.php",
        );

        if (tiposIVAResponse) {
          setDatosIVA(tiposIVAResponse);

          const encontrado = tiposIVAResponse.find(
            (item) => item.tipoRegimen === json_optica.idTipoIVA,
          );
          setIvaSeleccionado(encontrado || null);
        }
      } else {
        setNombre("");
        setNombreCorto("");
        setNRS("");
        setDireccion("");
        setCodigoPostal("");
        setLocalidad("");
        setProvincia("");
        setTelefono("");
        setMovil("");
        setEmail("");
        setTextoRGPD("");
        setConsentimientoOrtoK("");
        setConsentimientoLC("");
        setConsentimientoAudio("");
        setCartaGarantia("");
        setJustificanteAsistencia("");
        setClausulasFacturasPresupuestos("");
        setClausulasFichasPaciente("");
        setIdTipoIVA("");
        setTieneRecargoEquivalencia("");
      }

      setIsLoading(false);
    }
    obtenerOptica();
  }, [props.opticId]);

  const discardChanges = () => {
    if (originalData) {
      setNombre(originalData.nombre);
      setNombreCorto(originalData.nombreCorto);
      setNRS(originalData.NRS);
      setDireccion(originalData.direccion);
      setCodigoPostal(originalData.codigoPostal);
      setLocalidad(originalData.localidad);
      setProvincia(originalData.provincia);
      setTelefono(originalData.telefono);
      setMovil(originalData.movil);
      setEmail(originalData.email);
      setTextoRGPD(originalData.textoRGPD);
      setConsentimientoOrtoK(originalData.consentimientoOrtoK);
      setConsentimientoLC(originalData.consentimientoLC);
      setConsentimientoAudio(originalData.consentimientoAudio);
      setCartaGarantia(originalData.cartaGarantia);
      setJustificanteAsistencia(originalData.justificanteAsistencia);
      setClausulasFacturasPresupuestos(
        originalData.clausulasFacturasPresupuestos,
      );
      setClausulasFichasPaciente(originalData.clausulasFichasPaciente);
      setIdTipoIVA(originalData.idTipoIVA);
      setTieneRecargoEquivalencia(originalData.tieneRecargoEquivalencia);
    } else {
      setNombre("");
      setNombreCorto("");
      setNRS("");
      setDireccion("");
      setCodigoPostal("");
      setLocalidad("");
      setProvincia("");
      setTelefono("");
      setMovil("");
      setEmail("");
      setTextoRGPD("");
      setConsentimientoOrtoK("");
      setConsentimientoLC("");
      setConsentimientoAudio("");
      setCartaGarantia("");
      setJustificanteAsistencia("");
      setClausulasFacturasPresupuestos("");
      setClausulasFichasPaciente("");
      setIdTipoIVA("");
      setTieneRecargoEquivalencia("");
    }

    props.closeFunction(); // cerrar popup
  };

  const saveOpticData = async () => {
    if (!minimunData()) {
      props.createPopupQuestion(
        `Los campos con (*) son obligatorios.`,
        props.removePopupQuestion,
        null,
        "Entendido",
      );
    } else {
      let json_query = {
        token: tokenSesion,
        idOptica: idOptica,
        idEmpresa: idEmpresa,
        nombre: nombre,
        nombre_corto: nombreCorto,
        NRS: NRS,
        direccion: direccion,
        codigo_postal: codigoPostal,
        localidad: localidad,
        provincia: provincia,
        telefono: telefono,
        movil: movil,
        email: email || "",
        texto_rgpd: textoRGPD,
        consentimiento_ortoK: consentimientoOrtoK,
        consentimiento_lc: consentimientoLC,
        consentimiento_audio: consentimientoAudio,
        carta_garantia: cartaGarantia,
        justificante_asistencia: justificanteAsistencia,
        clausulas_facturas_presupuestos: clausulasFacturasPresupuestos,
        clausulas_fichas_paciente: clausulasFichasPaciente,
        idTipoIVA: idTipoIVA,
        tieneRecargoEquivalencia: tieneRecargoEquivalencia,
      };

      let newIdOptica = -1;
      let error = "";

      //console.log("JSON ÓPTICA ENVIADO: ", json_query);

      await post("Configuracion/GuardarOptica.php", json_query).then((data) => {
        newIdOptica = data.idOptica;
        error = data.error;
      });

      if (flagNewComercialLogo === true) {
        let json_logo_comercial = {
          token: tokenSesion,
          idOptica: newIdOptica,
          logo: opticComercialLogo,
          nombreFichero: opticComercialLogoName,
        };
        //console.log(json_logo_comercial);
        await post("Configuracion/SubirLogoComercial.php", json_logo_comercial);
      }

      if (flagDeleteComercialLogo === true) {
        let json_delete_logoc = {
          token: tokenSesion,
          idOptica: idOptica,
        };

        await post(
          "Configuracion/EliminarLogoComercial.php",
          json_delete_logoc,
        );
      }

      if (flagNewTicketLogo === true) {
        let json_logo_ticket = {
          token: tokenSesion,
          idOptica: newIdOptica,
          logo: opticTicketLogo,
          nombreFichero: opticTicketLogoName,
        };
        //console.log(json_logo_ticket);
        await post("Configuracion/SubirLogoTicket.php", json_logo_ticket);
      }

      if (flagDeleteTicketLogo === true) {
        let json_delete_logot = {
          token: tokenSesion,
          idOptica: idOptica,
        };

        await post("Configuracion/EliminarLogoTicket.php", json_delete_logot);
      }

      if (newIdOptica === -1) {
        // console.log(error);
        props.createPopupQuestion(
          `Ocurrió un error al grabar los datos.`,
          props.removePopupQuestion,
          null,
          "Entendido",
        );
        return false;
      } else {
        if (props.onSave) {
          props.onSave(newIdOptica);
        }
        // setIdOptica(newIdOptica);
        return true;
      }
    }
  };

  const deleteOpticComercialLogo = () => {
    setOpticComercialLogo(null);
    setFlagDeleteComercialLogo(true);
  };

  const deleteOpticTicketLogo = () => {
    setOpticTicketLogo(null);
    setFlagDeleteTicketLogo(true);
  };

  const handleClose = () => {
    if (hasChanges()) {
      props.createPopupQuestion(
        `Hay cambios sin guardar. ¿Seguro que quieres salir sin guardar?`,
        async () => {
          discardChanges();
          props.removePopupQuestion();
        },
        props.removePopupQuestion,
        "Sí",
        "No",
      );
    } else {
      props.closeFunction();
    }
  };

  const hasChanges = () => {
    if (!originalData) return false;

    return (
      nombre !== originalData.nombre ||
      nombreCorto !== originalData.nombreCorto ||
      NRS !== originalData.NRS ||
      direccion !== originalData.direccion ||
      codigoPostal !== originalData.codigoPostal ||
      localidad !== originalData.localidad ||
      provincia !== originalData.provincia ||
      telefono !== originalData.telefono ||
      movil !== originalData.movil ||
      email !== originalData.email ||
      textoRGPD !== originalData.textoRGPD ||
      consentimientoOrtoK !== originalData.consentimientoOrtoK ||
      consentimientoLC !== originalData.consentimientoLC ||
      consentimientoAudio !== originalData.consentimientoAudio ||
      cartaGarantia !== originalData.cartaGarantia ||
      justificanteAsistencia !== originalData.justificanteAsistencia ||
      clausulasFacturasPresupuestos !==
        originalData.clausulasFacturasPresupuestos ||
      clausulasFichasPaciente !== originalData.clausulasFichasPaciente ||
      idTipoIVA !== originalData.idTipoIVA ||
      tieneRecargoEquivalencia !== originalData.tieneRecargoEquivalencia
    );
  };

  const handleComboIVA = (id) => {
    setIdTipoIVA(id);
  };

  const showPopupCPDialog = (show, address, city) => {
    setCPPopupAddress(address);
    setCPPopupCity(city);
    setShowPopupCP(show);
  };

  const onAcceptCP = (fullAddress) => {
    setCodigoPostal(fullAddress.postalCode);
    showPopupCPDialog(false, "", "");
  };

  useEffect(() => {
    if (datosIVA.length > 0 && idTipoIVA !== null) {
      const iva = datosIVA.find((item) => item.tipoRegimen === idTipoIVA);
      setIvaSeleccionado(iva || null);
    }
  }, [idTipoIVA, datosIVA]);

  const opcionesComboIVA = datosIVA.map((el) => ({
    id: el.tipoRegimen,
    text: el.descripcion,
  }));

  const minimunData = () => {
    return (
      // Usa ?.trim() para evitar crasheos si la variable es null/undefined
      nombre?.trim() &&
      nombreCorto?.trim() &&
      direccion?.trim() &&
      codigoPostal?.trim() &&
      localidad?.trim() &&
      provincia?.trim() &&
      (telefono?.trim() || movil?.trim())
    );
  };

  /*if (!props.show) {
    return <></>;
  }*/

  if (isLoading) {
    return <div className="spinner" />;
  }

  return (
    <div className="popup-container popup-normal popup-settings-company">
      <div className="popup-message">
        <div className="popup-header">
          <div className="popup-title">Datos de óptica</div>
          <img
            src="images/close-white.svg"
            loading="lazy"
            alt=""
            className="popup-close"
            onClick={() => {
              handleClose();
            }}
          />
        </div>
        <div className="popup-body">
          <div className="optic-section-content">
            <div className="optic-section-content-data">
              <div className="optic-data-field-row">
                <div className="optic-data-field d-optic-large">
                  <span className="label">Nombre (*)</span>
                  <InputData
                    tabIndex={1}
                    id="nombre"
                    type="type-type-alphanum-ext"
                    size={6}
                    input={nombre}
                    onChange={(e) => {
                      setNombre(e);
                    }}
                  />
                </div>
              </div>
              <div className="optic-data-field-row-extra">
                <div className="optic-data-field d-optic-large">
                  <span className="label">Nombre corto (*)</span>
                  <InputData
                    id="nombre_corto"
                    type="type-type-alphanum-ext"
                    tabIndex={2}
                    size={6}
                    input={nombreCorto}
                    onChange={(e) => {
                      setNombreCorto(e);
                    }}
                  ></InputData>
                </div>
                <div className="optic-data-field-extra d-optic-large">
                  <span className="label">NRS</span>
                  <InputData
                    tabIndex={3}
                    id="NRS"
                    type="type-only-charnumbers"
                    size={6}
                    input={NRS}
                    onChange={(e) => {
                      setNRS(e);
                    }}
                  ></InputData>
                </div>
              </div>
              <div className="optic-data-field-row">
                <div className="optic-data-field d-optic-large">
                  <span className="label">Dirección (*)</span>
                  <InputData
                    tabIndex={4}
                    id="direccion"
                    type="type-type-alphanum-ext"
                    size={6}
                    input={direccion}
                    onChange={(e) => {
                      setDireccion(e);
                    }}
                  ></InputData>
                </div>
              </div>
              <div className="optic-data-field-row">
                <div className="optic-data-field d-optic-large">
                  <span className="label">Localidad (*)</span>
                  <InputData
                    tabIndex={4}
                    id="localidad"
                    type="type-alpha"
                    size={6}
                    input={localidad}
                    onChange={(e) => {
                      setLocalidad(e);
                    }}
                  ></InputData>
                </div>
              </div>
              <div className="optic-data-field-row">
                <div className="optic-data-field d-optic-large">
                  <span className="label">Código postal (*)</span>
                  <InputData
                    id="codigo_postal"
                    tabIndex={14}
                    type="type-cp"
                    maxLength={5}
                    size={6}
                    input={codigoPostal}
                    onChange={(e) => {
                      setCodigoPostal(e);
                    }}
                    onMalformed={() => setErrorCP(true)}
                    error={errorCP}
                    icon="/images/link.svg"
                    onClick={() =>
                      showPopupCPDialog(true, direccion, localidad)
                    }
                  ></InputData>
                </div>
                <div className="optic-data-field-extra d-optic-large">
                  <span className="label">Provincia (*)</span>
                  <Dropdown
                    tabIndex={7}
                    id="provincia"
                    disabled={false}
                    optionList={provinceOptions}
                    size={0}
                    op={provincia}
                    onChange={(e) => {
                      setProvincia(e.text);
                    }}
                  ></Dropdown>
                </div>
              </div>
              <div className="optic-data-field-row-extra">
                <div className="optic-data-field d-optic-large">
                  <span className="label">Teléfono (*)</span>
                  <InputData
                    id="telefono_fijo"
                    tabIndex={9}
                    type="type-phone"
                    size={6}
                    input={telefono}
                    onChange={(e) => {
                      setTelefono(e);
                    }}
                  ></InputData>
                </div>
                <div className="optic-data-field-extra d-optic-large">
                  <span className="label">Móvil (*)</span>
                  <InputData
                    id="movil"
                    tabIndex={10}
                    type="type-phone"
                    size={6}
                    input={movil}
                    onChange={(e) => {
                      setMovil(e);
                    }}
                  ></InputData>
                </div>
              </div>
              <div className="optic-data-field-row">
                <div className="optic-data-field d-optic-large">
                  <span className="label">Email</span>
                  <InputData
                    id="email"
                    tabIndex={8}
                    type="type-email"
                    size={6}
                    input={email}
                    onChange={(e) => {
                      setEmail(e);
                    }}
                    onMalformed={() => setErrorEmail(true)}
                    error={errorEmail}
                  ></InputData>
                </div>
              </div>
              <div className="optic-data-field-row-extra">
                <div className="optic-data-field d-optic-large">
                  <span className="label">Tipo impuesto</span>
                  <Dropdown
                    tabIndex={11}
                    id="tipo-impuesto"
                    disabled={false}
                    optionList={opcionesComboIVA}
                    size={0}
                    op={idTipoIVA}
                    onChange={(e) => {
                      handleComboIVA(e.id);
                    }}
                  />
                </div>
                <div className="optic-data-field-extra d-optic-large">
                  <CheckBox
                    id="recargo"
                    tabIndex={2}
                    active={tieneRecargoEquivalencia}
                    onClick={() => {
                      setTieneRecargoEquivalencia(!tieneRecargoEquivalencia);
                    }}
                  />
                  <span className="label chklabel">
                    Recargo de equivalencia
                  </span>
                </div>
              </div>
            </div>
            {ivaSeleccionado && datosIVA.length > 0 && (
              <TablaIVA iva={ivaSeleccionado} />
            )}
            <div className="optic-logo-container">
              <div>
                <span className="label">Logotipo comercial</span>
                <div className="patient-info-1">
                  <LogoImg
                    id="comercial-logo"
                    img={opticComercialLogo}
                    onUpload={(img) => {
                      setOpticComercialLogo(img);
                      setFlagNewComercialLogo(true);
                    }}
                    onDelete={() => {
                      props.createPopupQuestion(
                        `¿Desea eliminar el logotipo asociado a esta óptica?`,
                        async () => {
                          deleteOpticComercialLogo();
                          props.removePopupQuestion();
                        },
                        props.removePopupQuestion,
                        "Sí",
                        "No",
                      );
                    }}
                  />
                </div>
              </div>
              <div>
                <span className="label">Logotipo ticket</span>
                <div className="patient-info-1">
                  <LogoImg
                    id="ticket-logo"
                    img={opticTicketLogo}
                    onUpload={(img) => {
                      setOpticTicketLogo(img);
                      setFlagNewTicketLogo(true);
                    }}
                    onDelete={() => {
                      props.createPopupQuestion(
                        `¿Desea eliminar el logotipo asociado a esta óptica?`,
                        async () => {
                          deleteOpticTicketLogo();
                          props.removePopupQuestion();
                        },
                        props.removePopupQuestion,
                        "Sí",
                        "No",
                      );
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="optic-tab-container">
              <span className="label">
                Protección de datos y consentimientos
              </span>
              <div className="optic-data-content optic-data-content-settings">
                <div className="optic-settings-panel">
                  <div className="optic-tab-header">
                    <Tab
                      text="RGPD"
                      icon="/images/settings/pacientes.svg"
                      selected={selectedTabConsentimientos === 0}
                      onClick={() => setSelectedTabConsentimientos(0)}
                    />
                    <Tab
                      text="Consentimiento ORTO-K"
                      icon="/images/settings/pacientes.svg"
                      selected={selectedTabConsentimientos === 1}
                      onClick={() => setSelectedTabConsentimientos(1)}
                    />
                    <Tab
                      text="Consentimiento LC"
                      icon="/images/settings/pacientes.svg"
                      selected={selectedTabConsentimientos === 2}
                      onClick={() => setSelectedTabConsentimientos(2)}
                    />
                    <Tab
                      text="Consentimiento AUDIO"
                      icon="/images/settings/pacientes.svg"
                      selected={selectedTabConsentimientos === 3}
                      onClick={() => setSelectedTabConsentimientos(3)}
                    />
                    <Tab
                      text="Carta de garantía"
                      icon="/images/settings/pacientes.svg"
                      selected={selectedTabConsentimientos === 4}
                      onClick={() => setSelectedTabConsentimientos(4)}
                    />
                    <Tab
                      text="Justificante de asistencia"
                      icon="/images/settings/pacientes.svg"
                      selected={selectedTabConsentimientos === 5}
                      onClick={() => setSelectedTabConsentimientos(5)}
                    />
                  </div>
                  <div className="optic-setting-body">
                    <InputTextAreaContainer
                      ref={(el) => (consentimientosRefs.current[0] = el)}
                      show={selectedTabConsentimientos === 0}
                      inputText={textoRGPD}
                      onChange={setTextoRGPD}
                    />
                    <InputTextAreaContainer
                      ref={(el) => (consentimientosRefs.current[1] = el)}
                      show={selectedTabConsentimientos === 1}
                      inputText={consentimientoOrtoK}
                      onChange={setConsentimientoOrtoK}
                    />
                    <InputTextAreaContainer
                      ref={(el) => (consentimientosRefs.current[2] = el)}
                      show={selectedTabConsentimientos === 2}
                      inputText={consentimientoLC}
                      onChange={setConsentimientoLC}
                    />
                    <InputTextAreaContainer
                      ref={(el) => (consentimientosRefs.current[3] = el)}
                      show={selectedTabConsentimientos === 3}
                      inputText={consentimientoAudio}
                      onChange={setConsentimientoAudio}
                    />
                    <InputTextAreaContainer
                      ref={(el) => (consentimientosRefs.current[4] = el)}
                      show={selectedTabConsentimientos === 4}
                      inputText={cartaGarantia}
                      onChange={setCartaGarantia}
                    />
                    <InputTextAreaContainer
                      ref={(el) => (consentimientosRefs.current[5] = el)}
                      show={selectedTabConsentimientos === 5}
                      inputText={justificanteAsistencia}
                      onChange={setJustificanteAsistencia}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="optic-tab-container">
              <span className="label">Configuración de cláusulas</span>
              <div className="optic-data-content optic-data-content-settings">
                <div className="optic-settings-panel">
                  <div className="optic-tab-header">
                    <Tab
                      text="Facturas y presupuestos"
                      icon="/images/settings/pacientes.svg"
                      selected={selectedTabClausulas === 6}
                      onClick={() => setSelectedTabClausulas(6)}
                    />
                    <Tab
                      text="Fichas de paciente"
                      icon="/images/settings/pacientes.svg"
                      selected={selectedTabClausulas === 7}
                      onClick={() => setSelectedTabClausulas(7)}
                    />
                  </div>
                  <div className="optic-setting-body">
                    <InputTextAreaContainer
                      ref={(el) => (clausulasRefs.current[6] = el)}
                      show={selectedTabClausulas === 6}
                      inputText={clausulasFacturasPresupuestos}
                      onChange={setClausulasFacturasPresupuestos}
                    />
                    <InputTextAreaContainer
                      ref={(el) => (clausulasRefs.current[7] = el)}
                      show={selectedTabClausulas === 7}
                      inputText={clausulasFichasPaciente}
                      onChange={setClausulasFichasPaciente}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="popup-row-buttons-container">
            <div className="popup-row-buttons">
              <ButtonIconH
                text="Cancelar"
                onClick={() => {
                  handleClose();
                }}
              />
              <ButtonIconH
                text="Guardar"
                onClick={() => {
                  props.createPopupQuestion(
                    `¿Desea guardar los cambios realizados en esta óptica?`,
                    async () => {
                      const guardadoExitoso = await saveOpticData();

                      if (guardadoExitoso) {
                        props.removePopupQuestion();
                        props.closeFunction();
                      }
                    },
                    props.removePopupQuestion,
                    "Sí",
                    "No",
                  );
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <PopupCP
        show={showPopupCP}
        direccion={cpPopupAddress}
        localidad={cpPopupCity}
        onAccept={(fullAddress) => onAcceptCP(fullAddress)}
        onCancel={() => showPopupCPDialog(false, "", "")}
      />
    </div>
  );
}
